import React from 'react';
import * as S from './style'

function Item({titulo, descricao, preco, imagem, time, indisponivel = false, _handleExpand}) {
  return (
    <S.CardButton onClick={ _handleExpand } $indisponivel={ indisponivel }>
      <S.Container $hasTime={ !!time } $indisponivel={ indisponivel }>
        { time ? <S.Time $indisponivel={ indisponivel }>{ time }</S.Time> : null }
        <S.LeftSide>
          <S.Topo>
            <h1>{titulo}</h1>
            <div dangerouslySetInnerHTML={{ __html: descricao || '' }}></div>
          </S.Topo>
          {
            preco ? (
              <h2>{preco}</h2>
            ) : null
          }
        </S.LeftSide>
        <S.RightSide
          // bg={ `${  imagem }` }
          bg={ imagem }
        >
          <img
            // src={ `${  imagem }` }
            src={ imagem }
            alt=""
          />
        </S.RightSide>
      </S.Container>
    </S.CardButton>
  )
}

export default Item;
